import { render, staticRenderFns } from "./legaltaps.vue?vue&type=template&id=4e4a4a9a&"
import script from "./legaltaps.vue?vue&type=script&lang=js&"
export * from "./legaltaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports